import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackComponent } from './feedback.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlTextareaModule } from '@app/components/pl-textarea/pl-textarea.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    ButtonModule,
    PlInputModule,
    FormsModule,
    PlTextareaModule,
    ReactiveFormsModule,
  ],
  declarations: [FeedbackComponent],
  exports: [FeedbackComponent],
})
export class FeedbackModule {}
